@switch (page()) {
  @case (exchange.Set) {
    <kr-exchange-set-crypto-crypto [wallets]="wallets()" [form]="form" />
    <div class="kr-actions">
      <div>
        <button
          type="button"
          fuButton
          size="m"
          uiType="primary"
          data-testid="exchange_crypto_crypto_close_btn"
          (click)="dialogRef.close()"
          class="kr-button-back"
          translate="exchange.dialog.back"></button>
      </div>
      <button
        type="button"
        fuButton
        size="m"
        uiType="primary"
        data-testid="exchange_crypto_crypto_details_btn"
        (click)="setStep(exchange.Details)"
        translate="exchange.dialog.nextStep"></button>
    </div>
  }
  @case (exchange.Details) {
    <kr-exchange-crypto-details
      [form]="form"
      [wallets]="wallets()"
      (timeLeftChange)="timeLeft.set($event)" />
    <div class="kr-actions">
      <button
        type="button"
        fuButton
        size="m"
        uiType="primary"
        data-testid="exchange_crypto_crypto_back_btn"
        (click)="page.set(exchange.Set)"
        translate="exchange.dialog.back"></button>

      <button
        type="button"
        fuButton
        size="m"
        uiType="primary"
        data-testid="exchange_crypto_crypto_execute_btn"
        [disabled]="timeLeft() === 0"
        (click)="execute()"
        translate="exchange.dialog.execute"></button>
    </div>
  }
  @case (exchange.Success) {
    <kr-exchange-success />
  }
  @case (exchange.Failed) {
    <kr-exchange-failed />
  }
}
